import { render, staticRenderFns } from "./search-contact-list.vue?vue&type=template&id=74a4d598&scoped=true&"
import script from "./search-contact-list.vue?vue&type=script&lang=js&"
export * from "./search-contact-list.vue?vue&type=script&lang=js&"
import style0 from "./search-contact-list.vue?vue&type=style&index=0&id=74a4d598&lang=sass&scoped=true&"
import style1 from "./search-contact-list.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a4d598",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VBtn,VList,VListItem,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74a4d598')) {
      api.createRecord('74a4d598', component.options)
    } else {
      api.reload('74a4d598', component.options)
    }
    module.hot.accept("./search-contact-list.vue?vue&type=template&id=74a4d598&scoped=true&", function () {
      api.rerender('74a4d598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/search-contact-list/search-contact-list.vue"
export default component.exports